// pages/rules/RulesFormContent.tsx
import { Col, Divider } from 'antd';
import { ruleOutputItem, ruleTypeItem } from 'pages/rules/collapseItem';
import FeelExpressionForm from 'pages/rules/feelExpressionForm';
import { RuleApplicability } from 'pages/rules/subComponents';
import PureNumberInput from 'components/number/pureNumberInput';

const RulesFormContent = ({
  type,
  form,
  fileType,
  defaultFileListObj,
  uploadType,
  selectedAdjustmentLevel,
  groupConfigFields,
  state,
  ruleGroupConfigurationStatus,
  showRuleApplicability,
  showFeelExpression,
  isClawbackDirect,
  isClawbackNotSelected,
  clawbackType,
}) => {
  if (ruleGroupConfigurationStatus === false) {
    return (
      <Col md={6}>
        <PureNumberInput
          label="Enter Amount"
          name="enter_amount"
          required={true}
          message="Please enter an amount"
          placeholder="Enter amount"
          disabled={type === 'Show'}
        />
      </Col>
    );
  }

  if (isClawbackDirect || isClawbackNotSelected) return null;

  return (
    <>
      {showRuleApplicability ? (
        <>
          <Divider className="border-gray-200 mt-0" />
          <RuleApplicability
            type={type}
            form={form}
            configFields={state.configFields}
            disabled={type === 'Show'}
            ruleApplicabilityError={state.ruleApplicabilityError}
            isSavedClick={state.isSavedClick}
          />
        </>
      ) : null}
      <Divider className="border-gray-200 mt-7" />
      {ruleTypeItem(
        fileType,
        defaultFileListObj,
        uploadType,
        form,
        type,
        clawbackType
      )}

      {showFeelExpression ? (
        <>
          <div style={{ display: 'none' }}>
            <Divider className="border-gray-200" />
            {ruleOutputItem()}
          </div>
          <Divider className="border-gray-200" />
          <FeelExpressionForm
            type={type}
            disabled={type === 'Show'}
            form={form}
            forceShow={!!(clawbackType === 'PARTIAL' && type !== 'Show')}
            configFields={
              selectedAdjustmentLevel === 'group'
                ? groupConfigFields
                : state.configFields
            }
          />
        </>
      ) : null}
    </>
  );
};

export default RulesFormContent;
